import React, { useContext, useState } from "react";
import {
  logoArla,
  logoCmp,
  logoDps,
  logoPrs,
  logoNrla,
  logoCiol,
  logoAckroyd,
  logoBarclays,
  logoBlick,
  logoBurlingtons,
  logoCiti,
  logoDamac,
  logoDeloitte,
  logoEfg,
  logoEmaar,
  logoEy,
  logoIaa,
  logoKpmg,
  logoPwc,
  logoSpencerWest,
  logoStep,
  logoUbs,
} from "../../assets/assetsExport";
import { useSelector } from "react-redux";
import { getIsNarrowScreen, getLang } from "../../features/app/appSlice";
import SlideUpAnimation from "../SlideUpAnimation/SlideUpAnimation";
import styles from "./Partnerships.module.scss";
export default function Partnerships() {
  const lang = useSelector(getLang);
  const [showAll, setShowAll] = useState(false);
  const partners = [
    logoArla,
    logoCmp,
    logoDps,
    logoPrs,
    logoNrla,
    logoCiol,
    logoAckroyd,
    logoBarclays,
    logoBlick,
    logoBurlingtons,
    logoCiti,
    logoDamac,
    logoDeloitte,
    logoEfg,
    logoEmaar,
    logoEy,
    logoIaa,
    logoKpmg,
    logoPwc,
    logoSpencerWest,
    logoStep,
    logoUbs,
  ];
  const imgClass = "grayscale h-10 object-contain mx-2 opacity-60";
  const firstRowCount = 10;
  const secondRowCount = 8;

  return (
    <div className="border-t border-black pt-6 my-32">
      <h2 className="font-header text-3xl mb-10 leading-normal">
        {lang ? "Partnerships" : "合作伙伴"}
      </h2>
      <div className="flex flex-col gap-12">
        {showAll ? (
          <div className="flex flex-wrap  justify-between">
            {partners.map((partner, index) => (
              <img
                key={`partner-all-${index}`}
                src={partner}
                alt={`Partner ${index + 1}`}
                className={imgClass + " mb-16"}
              />
            ))}
          </div>
        ) : (
          <>
            <div className={styles.scrollContainer}>
              <div className={styles.scrollContentLeft}>
                {partners
                  .slice(0, firstRowCount)
                  .concat(partners.slice(0, firstRowCount))
                  .map((partner, index) => (
                    <img
                      key={`partner-row-1-${index}`}
                      src={partner}
                      alt={`Partner ${index + 1}`}
                      className={imgClass}
                    />
                  ))}
              </div>
            </div>
            <div className={styles.scrollContainer}>
              <div className={styles.scrollContentRight}>
                {partners
                  .slice(firstRowCount, firstRowCount + secondRowCount)
                  .concat(
                    partners.slice(
                      firstRowCount,
                      firstRowCount + secondRowCount
                    )
                  )
                  .map((partner, index) => (
                    <img
                      key={`partner-row-2-${index}`}
                      src={partner}
                      alt={`Partner ${index + 9}`}
                      className={imgClass}
                    />
                  ))}
              </div>
            </div>
            <div className={styles.scrollContainer}>
              <div className={styles.scrollContentLeft}>
                {partners
                  .slice(firstRowCount + secondRowCount, partners.length)
                  .concat(
                    partners.slice(
                      firstRowCount + secondRowCount,
                      partners.length
                    )
                  )
                  .map((partner, index) => (
                    <img
                      key={`partner-row-3-${index}`}
                      src={partner}
                      alt={`Partner ${index + 17}`}
                      className={imgClass}
                    />
                  ))}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="w-full mx-auto flex justify-center">
        <button
          className=" mt-16 mb-20  text-gray-300"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll
            ? lang
              ? "Collapse"
              : "收起"
            : lang
            ? "Show All"
            : "显示全部"}
        </button>
      </div>
    </div>
  );
}
